import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MiscSvgComponent } from '@curbnturf/custom-svgs/src/lib/misc-svg/misc-svg.component';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';
import { AmenityType, IAmenity, ISignalReception, SignalStrength } from '@curbnturf/entities';

@Component({
  selector: 'curbnturf-amenity-display',
  templateUrl: './amenity-display.component.html',
  styleUrls: ['./amenity-display.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, NgClass, SiteSvgsComponent, MiscSvgComponent],
})
export class AmenityDisplayComponent {
  @Input() amenities?: IAmenity[];

  @Input() signalReceptions?: ISignalReception[] = [];

  amenityType = AmenityType;

  openDescriptions: { [index: number]: boolean } = {};

  toggleDescription(index: number) {
    this.openDescriptions[index] = !this.openDescriptions[index];
  }

  name(amenity: IAmenity): string {
    if (amenity && amenity.type && amenity.type === 'custom') {
      return amenity.custom || '';
    }

    if (amenity.type) {
      return this.amenityType[amenity.type];
    }

    return '';
  }

  options(amenity: IAmenity): string {
    switch (amenity.type as string) {
      case 'wifi': {
        const downUp = amenity.options ? amenity.options.split('/') : ['', ''];
        return `${downUp[0]} Mbps/${downUp[1]} Mbps`;
      }
      case 'electricity': {
        return `${amenity.options} Amps${amenity.options === '15' ? '/110V' : ''}`;
      }
      case 'water': {
        return amenity.options === 'direct'
          ? 'Direct Connection'
          : amenity.options === 'station'
            ? 'Fill Station'
            : 'Unknown';
      }
      case 'cell': {
        if (this.signalReceptions) {
          return this.signalReceptions.reduce((cellOptions, signalReception) => {
            cellOptions += `Provider: ${signalReception.source} Coverage: ${
              signalReception.strength && SignalStrength[signalReception.strength]
            }<br>`;
            return cellOptions;
          }, '');
        }
        return '';
      }
      default:
        return amenity.options || '';
    }
  }
}
